import React from "react";
import { size } from "lodash";
import { Form } from "../../../components/Form";
import { Input } from "../../../components/CustomInput";


const DocumentationForm = ({ initialValues={}, onSubmit, onCancel, ...props}) => {

    return(<Form
        title={(size(initialValues) ? "Edit" : "Add") + " link to documentation"}
        onSubmit={onSubmit}
        onCancel={() => onCancel()}
        initialValues={initialValues}
    >
        <Form.Item name="description" label="Title" required >
            <Input maxLength={60} />
        </Form.Item>
        <Form.Item name={"link"} label="Link" required validation={{ pattern: { value: /^https:\/\/(?:docs|howto)\.vmssoftware\.com(?:\/.*)?$/, message: "Invalid documentation URL." }}}>
            <Input />
        </Form.Item>
    </Form>)
};

export { DocumentationForm };